/**
 * Convenience Component that will alert the parent when pressed outside
 * of the child component
 *
 * Copied over from Maven Dispatch and subsequently doctorred from:
 * https://stackoverflow.com/questions/32553158/detect-click-outside-react-component
 */

import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

export const OutsideAlerter = ({
  refsList,
  onOutsideClick,
  children,
}: {
  refsList: any;
  onOutsideClick: any;
  children: any;
}) => {
  const handleClickOutside = (event: any) => {
    // Loops through the refs list and will return true on the first one that
    // contains the event.  Returns false if none of them do.
    const isInside = refsList
      .filter((ref: any) => !!ref.current)
      .some((ref: any) => ref.current.contains(event.target));
    if (isInside) return;

    event.stopPropagation();
    onOutsideClick(event);
  };

  useEffect(() => {
    document.addEventListener('mouseup', handleClickOutside);
    return () => {
      document.removeEventListener('mouseup', handleClickOutside);
    };
  }, []);

  return <div>{children}</div>;
};

OutsideAlerter.propTypes = {
  refsList: PropTypes.array.isRequired,
  onOutsideClick: PropTypes.func.isRequired,
};
